import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { API_URL } from "../../../config";

const AddModule = ({
  addModuleModal,
  setAddModuleModal,
  selectedDevice,
  setSelectedModules,
  godevicelist
}) => {
  const [modules, setModules] = useState([]);
  const [selectedModuleIds, setSelectedModuleIds] = useState([]);
  const [defaultModules, setDefaultModules] = useState([]);
  const [loading, setLoading] = useState(false);
const [successModal, setSuccessModal] = useState(false);

  

  // 🔹 Fetch modules
  const fetchModules = async () => {
    const res = await fetch(API_URL + "/get/all/modules");
    const data = await res.json();
    setModules(data.modules || []);
  };

  useEffect(() => {
    fetchModules();
  }, []);

useEffect(() => {
  if (!selectedDevice || modules.length === 0) return;

  // ✅ use module_ids directly from API
  const existingIds = selectedDevice.module_ids || [];

  // if it's string (sometimes API gives string)
  const parsedIds =
    typeof existingIds === "string"
      ? JSON.parse(existingIds)
      : existingIds;

  setSelectedModuleIds(parsedIds);
  setSelectedModules(parsedIds);

  // OPTIONAL: if you still want "Included Modules UI"
  const included = modules.filter((m) =>
    parsedIds.includes(m.id)
  );

  setDefaultModules(included);
}, [selectedDevice, modules]);

  // 🔹 Handle checkbox (only extra modules)
  const handleCheckboxChange = (module) => {
    // ❌ Prevent removing default modules
    if (defaultModules.some((m) => m.id === module.id)) {
      return;
    }

    let updatedIds = [];

    if (selectedModuleIds.includes(module.id)) {
      updatedIds = selectedModuleIds.filter((id) => id !== module.id);
    } else {
      updatedIds = [...selectedModuleIds, module.id];
    }

    setSelectedModuleIds(updatedIds);
    setSelectedModules(updatedIds);
  };


  const extraModules = modules.filter(
    (m) => !defaultModules.some((d) => d.id === m.id)
  );
const updateModules = async () => {
  try {
    setLoading(true);

    const payload = {
      serial_key: selectedDevice?.serial_key,
      module_ids: selectedModuleIds,
    };

    const res = await fetch(
      API_URL + "/add/capno-go/modules/device",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const result = await res.json();

    if (result.success) {
      setSuccessModal(true);
      setAddModuleModal(false);
    } else {
      alert(result.message);
    }
  } catch (err) {
    console.error(err);
    alert("Something went wrong");
  } finally {
    setLoading(false);
  }
};
  return (
 <>
    <Modal
      isOpen={addModuleModal}
      toggle={() => setAddModuleModal(false)}
      centered
    >
      <ModalHeader toggle={() => setAddModuleModal(false)}>
        Add Modules{" "}
        <span style={{ fontSize: "14px" }}>
          (Serial No : {selectedDevice?.serial_key})
        </span>
      </ModalHeader>

      <ModalBody>
        {/* ✅ Included Modules */}
        {defaultModules.length > 0 && (
          <div
            style={{
              marginBottom: "15px",
              padding: "10px",
              border: "1px solid #d4edda",
              borderRadius: "6px",
              background: "#f6ffed",
            }}
          >
            <strong style={{ color: "#28a745" }}>
              Included Modules 
            </strong>

            <ul
              style={{
                marginTop: "8px",
                paddingLeft: "18px",
                fontSize: "14px",
              }}
            >
              {defaultModules.map((m) => (
                <li key={m.id}>✅ {m.name}</li>
              ))}
            </ul>
          </div>
        )}

        {/* ✅ Extra Modules */}
        <div
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            border: "1px solid #eee",
            padding: "10px",
            borderRadius: "6px",
          }}
        >
          <strong>Add Available Modules</strong>

          {extraModules.length === 0 && (
            <p style={{ marginTop: "8px", fontSize: "13px" }}>
              No additional modules available
            </p>
          )}

          {extraModules.map((m) => (
            <div key={m.id} style={{ marginTop: "8px" }}>
              <input
                type="checkbox"
                checked={selectedModuleIds.includes(m.id)}
                onChange={() => handleCheckboxChange(m)}
              />
              <span style={{ marginLeft: "8px" }}>{m.name}</span>
            </div>
          ))}
        </div>
      </ModalBody>

      <ModalFooter>
        <ModalFooter style={{border:"none"}}>
  <div className="add-btn" style={{ display: "flex", gap: "10px" }}>
    <button onClick={() => setAddModuleModal(false)}>
      Cancel
    </button>

   <button
  onClick={updateModules}
  disabled={loading}
>
  {loading ? "Saving..." : "Save"}
</button>
  </div>
</ModalFooter>
      </ModalFooter>
    </Modal>
    <Modal isOpen={successModal} centered>
  <ModalHeader>
    Success
  </ModalHeader>

  <ModalBody style={{ textAlign: "center" }}>
    ✅ Modules updated successfully
  </ModalBody>

  <ModalFooter style={{border:"none"}} className="add-btn">
    <button
      onClick={() => {
        setSuccessModal(false);

        // optional: refresh device list
        if (godevicelist) {
          godevicelist();
        }
      }}
    >
      OK
    </button>
  </ModalFooter>
</Modal>
 </>
  );
};

export default AddModule;